import { CommonAPIService } from "@/serviceHandlers/CommonHandler";

export default class usersAPIService {
  constructor() {
    this.commonAPIservice = new CommonAPIService();
  }

  getUserInfo(userId, router) {
    const url = `/api/users/${userId}`;
    return this.commonAPIservice.getCall(url, "", router);
  }

  getUsers(router) {
    const url = "/api/users";
    return this.commonAPIservice.getCall(url, "", router);
  }

  createUser(params, router) {
    const url = "/api/users";
    return this.commonAPIservice.postCall(url, params, router);
  }

  updateUser(userId, params, router) {
    const url = `/api/users/${userId}`;
    return this.commonAPIservice.putCall(url, params, router);
  }

  deleteUser(userId, router) {
    const url = `/api/users/${userId}`;
    return this.commonAPIservice.deleteCall(url, "", router);
  }
}
